import { RankingHeader, RankingRequest } from '@features/rankings/models/ranking.model'
import { parseStatic } from '@core/utils/assets.utils'
import { StaticOrientation } from '@core/enums/statics.enum'
import { ComparableMetric, ListedMetric } from '@core/models/metric.models'
import { Match } from '@core/models/match.models'
import { Aggregation } from '@features/aggregations/models/aggregations.models'
import { PLACEHOLDER_IMAGES } from '@mediacoach/ui'

export const parseMatchToRankingRequest = (
  context: Match,
  value: ListedMetric | ComparableMetric,
  mode: Aggregation
): RankingRequest => ({
  seasonId: context.seasonId,
  competitionId: context.competitionId,
  metricName: value.key,
  matchId: context.id,
  teams: [context?.homeTeam?.teamId, context?.awayTeam?.teamId],
  aggregationDataSource: mode
})

export const parseMatchRankingHeader = (metricKey: string, metricContext: Match, matchDay: number): RankingHeader => ({
  title: metricKey,
  imageA: parseStatic(metricContext.homeTeam?.statics, StaticOrientation.Portrait),
  textA: metricContext.homeTeam?.shortName,
  imageB: parseStatic(metricContext.awayTeam?.statics, StaticOrientation.Portrait),
  textB: metricContext.awayTeam?.shortName,
  placeholderA: PLACEHOLDER_IMAGES.TEAM,
  placeholderB: PLACEHOLDER_IMAGES.TEAM,
  matchDay
})
